import component from './HashIcon'

export default component
